// Static platform taxonomy (countries, categories) — NOT business data.
// All business/listing data comes from the API.

export const COUNTRIES = [
  {
    code: 'albania',
    name: 'Albania',
    nativeName: 'Shqipëria',
    flag: '🇦🇱',
    color: '#E41E20',
    tagline: "Discover Albania's Hidden Gems",
    subtitle: 'Your Smart Guide to the Heart of Albania',
    heroImage: 'https://images.pexels.com/photos/33945650/pexels-photo-33945650.jpeg',
    stats: { businesses: 345, cities: 31, rating: 4.5 },
    available: true,
    cities: 31,
  },
  {
    code: 'kosovo',
    name: 'Kosovo',
    nativeName: 'Kosova',
    flag: '🇽🇰',
    color: '#244AA5',
    tagline: "Discover Kosovo's Hidden Gems",
    subtitle: "Your Smart Guide to Europe's Youngest Country",
    heroImage: 'https://images.pexels.com/photos/33092891/pexels-photo-33092891.jpeg',
    stats: { businesses: 168, cities: 12, rating: 4.6 },
    available: true,
    cities: 12,
  },
  {
    code: 'north-macedonia',
    name: 'North Macedonia',
    nativeName: 'Македонија',
    flag: '🇲🇰',
    color: '#D20000',
    tagline: "Discover North Macedonia's Hidden Gems",
    subtitle: 'Your Smart Guide to Lakes, Mountains & Crossroads',
    heroImage: 'https://images.unsplash.com/photo-1537113799915-0a24165b3f72',
    stats: { businesses: 192, cities: 18, rating: 4.7 },
    available: true,
    cities: 18,
  },
  // Future-ready
  { code: 'montenegro', name: 'Montenegro', nativeName: 'Crna Gora', flag: '🇲🇪', available: false },
  { code: 'greece', name: 'Greece', nativeName: 'Ελλάδα', flag: '🇬🇷', available: false },
  { code: 'serbia', name: 'Serbia', nativeName: 'Srbija', flag: '🇷🇸', available: false },
  { code: 'croatia', name: 'Croatia', nativeName: 'Hrvatska', flag: '🇭🇷', available: false },
];

export const CATEGORIES = [
  { slug: 'restaurant', name: 'Restaurants', emoji: '🍽️', count: 1240 },
  { slug: 'hotel', name: 'Hotels', emoji: '🏨', count: 480 },
  { slug: 'attraction', name: 'Attractions', emoji: '🎭', count: 540 },
  { slug: 'beach', name: 'Beaches', emoji: '🏖️', count: 86 },
  { slug: 'cafe', name: 'Cafés', emoji: '☕', count: 920 },
  { slug: 'bar', name: 'Bars & Nightlife', emoji: '🍹', count: 312 },
  { slug: 'museum', name: 'Museums', emoji: '🏛️', count: 92 },
  { slug: 'park', name: 'Parks', emoji: '🌳', count: 138 },
];

export const ALL_CATEGORIES = [
  ...CATEGORIES,
  { slug: 'villa', name: 'Villas & Apartments', emoji: '🏡', count: 540 },
  { slug: 'tour', name: 'Tours & Guides', emoji: '🗺️', count: 248 },
  { slug: 'taxi', name: 'Taxis & Transfers', emoji: '🚕', count: 138 },
  { slug: 'car-rental', name: 'Car Rentals', emoji: '🚗', count: 86 },
  { slug: 'shopping', name: 'Shopping', emoji: '🛍️', count: 410 },
  { slug: 'mobile-shop', name: 'Mobile Shops', emoji: '📱', count: 64 },
  { slug: 'electronics', name: 'Electronics', emoji: '🔌', count: 92 },
  { slug: 'cocktail-bar', name: 'Cocktail Bars', emoji: '🍸', count: 48 },
  { slug: 'beach-bar', name: 'Beach Bars', emoji: '🏝️', count: 64 },
  { slug: 'beach-club', name: 'Beach Clubs', emoji: '🌊', count: 38 },
  { slug: 'nightclub', name: 'Nightclubs', emoji: '🎶', count: 56 },
  { slug: 'lounge', name: 'Lounges', emoji: '🛋️', count: 32 },
  { slug: 'seafood', name: 'Seafood Restaurants', emoji: '🦞', count: 78 },
  { slug: 'pharmacy', name: 'Pharmacies', emoji: '💊', count: 220 },
  { slug: 'hospital', name: 'Hospitals', emoji: '🏥', count: 64 },
  { slug: 'gym', name: 'Gyms', emoji: '🏋️', count: 72 },
];
